<template>
  <el-dialog
    :before-close="fechar"
    :visible.sync="visibility"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="60%">
      <span slot="title">
        <font-awesome-icon icon="user-tie" />
        Selecionar Cliente 
      </span>

      <el-form size="mini" label-position="top">
        <el-row :gutter="20">
          <el-col :md="4" :lg="4">
            <el-form-item label="ID">
              <el-autocomplete
                v-model="clientePesquisa.idNaImobiliaria"
                :fetch-suggestions="idInputHandler"
                :debounce="1000"
                clearable
                @clear="limparIdClientePesquisaHandler"
                :trigger-on-focus="false"
                :hide-loading="true"
                popper-class="invisible-autocomplete-popper"
                style="width: 100%">
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :md="20" :lg="20">
            <el-form-item label="Nome/Razão Social">
              <el-autocomplete
                v-model="clientePesquisa.nome"
                :fetch-suggestions="nomeInputHandler"
                :debounce="1000"
                clearable
                @clear="limparNomeClientePesquisaHandler"
                :trigger-on-focus="false"
                :hide-loading="true"
                popper-class="invisible-autocomplete-popper"
                style="width: 100%">
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row type="flex" justify="end">
        <h4 style="color: #606266; margin: 0px 15px 5px 0px">{{ this.labelQuantidade }}</h4>
      </el-row>

      <el-table
        :data="clientes"
        highlight-current-row
        @current-change="selecaoLinhaHandler"
        @row-dblclick="cliqueDuploLinhaHandler"
        empty-text="Nenhum Cliente encontrado"
        height="250"
        stripe
      >
        <el-table-column
          prop="idNaImobiliaria"
          label="ID"
          sortable
          width="90"
          show-overflow-tooltip
        />

        <el-table-column
          prop="nome"
          label="Nome/Razão Social"
          sortable
          show-overflow-tooltip
        />

        <el-table-column
          prop="cpfCnpj"
          label="CPF/CNPJ"
          sortable
          width="180"
          show-overflow-tooltip
        />

        <infinite-loading
          :identifier="infiniteLoadingId"
          slot="append"
          @infinite="pesquisar"
          force-use-infinite-wrapper=".el-table__body-wrapper"
        >
          <div slot="no-more" />
          <div slot="no-results" />
        </infinite-loading>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="selecionarClienteHandler"
          type="success"
          size="small"
          round
          class="btn-box-shadow"
        >
        <i class="el-icon-check" />
          Selecionar 
        </el-button>

        <el-button
          @click="fechar"
          type="danger"
          size="small"
          round
          class="btn-box-shadow"
        >
        <i class="el-icon-close" />
          Fechar 
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      infiniteLoadingId: 0,
      linhaSelecionada: undefined
    }
  },
  watch: {
    'clientePesquisa.idNaImobiliaria': function(newValue) {
      if(newValue === "") { this.dispararPesquisa() }
    },
    'clientePesquisa.nome': function(newValue) {
      if(newValue === "") { this.dispararPesquisa() }
    }
  },
  computed: {
    ...mapState('logsAcessoStore', {
      clientes(state) { return state.listaClientes },
      labelQuantidade(state) { return state.labelQuantidadeClientes },
      clientePesquisa(state) { return state.clientePesquisa },
      logPesquisa(state) { return state.logPesquisa }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('logsAcessoStore', [
      'listarClientes',
      'limparClientesListados',
      'limparClientePesquisa'
    ]),
    fechar() {
      this.linhaSelecionada = undefined;
      this.limparClientePesquisa();
      this.listarClientes(this.clientePesquisa).then(() => {});
      this.$emit('close');
    },
    pesquisar($state) {
      if(this.clientePesquisa.pagina === 0) { this.showLoading(); }
      this.listarClientes(this.clientePesquisa)
        .then((resultado) => {
          if(this.clientePesquisa.pagina === 0) { this.hideLoading(); }
          if(resultado.lista.length === 100) {
            this.clientePesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.clientePesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.clientePesquisa.pagina === 0) { this.hideLoading(); }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    dispararPesquisa() {
      this.clientePesquisa.pagina = 0;
      this.limparClientesListados();
      this.infiniteLoadingId += 1;
    },
    nomeInputHandler(value) {
      this.clientePesquisa.nome = value;
      this.dispararPesquisa();
    },
    idInputHandler(value) {
      this.clientePesquisa.idNaImobiliaria = value;
      this.dispararPesquisa();
    },
    selecaoLinhaHandler(currentRow) {
      this.linhaSelecionada = currentRow;
    },
    selecionarClienteHandler() {
      if(!this.linhaSelecionada) {
        this.$message.warning("Selecione um Cliente na tabela");
        return;
      }
      this.logPesquisa.cliente = this.linhaSelecionada;
      this.fechar();
    },
    cliqueDuploLinhaHandler(row) {
      this.logPesquisa.cliente = row;
      this.fechar();
    },
    limparIdClientePesquisaHandler() {
      this.dispararPesquisa();
    },
    limparNomeClientePesquisaHandler() {
      this.dispararPesquisa();
    }
  }
}
</script>